module.exports = "/images/cl.svg?9a572260ae3e2459e56dcaf0b8f09c31";